const initStepsCards = () => {
  const wrapper = document.querySelector(".wrapper");
  const steps = document.querySelectorAll("[data-step]");
  if (!steps.length) return;
  
  const onCardEvent = (evt) => {
    if (evt.target.closest("[data-step]")) {
      const targetCard = evt.target.closest("[data-step]");
      const activeCard = document.querySelector("[data-step].is-active");
      activeCard.classList.remove('is-active');
      targetCard.classList.add('is-active');
    };
  };
  
  wrapper.addEventListener("mouseover", onCardEvent);
  wrapper.addEventListener("click", onCardEvent);
  wrapper.addEventListener("focusin", onCardEvent);
};

export default initStepsCards;
